import { type ReactNode } from "react";

import { SxProps, Theme } from "@mui/material";

import FilterChip from "@/src/components/atoms/FilterChip";

import { VehicleType } from "@/src/pages/dealer/components/VehicleCheckBoxGroup/VehicleCheckBoxGroup";

interface VehicleCheckBoxProps {
  label: string;
  icon?: ReactNode;
  value: VehicleType;
  isChecked: boolean;
  onToggle: (value: VehicleType) => void;
  hideLabelOnMobile?: boolean;
  sx?: SxProps<Theme>;
}

const VehicleCheckBox = ({
  label,
  icon,
  value,
  isChecked,
  onToggle,
  hideLabelOnMobile,
  sx
}: VehicleCheckBoxProps) => {
  const handleToggle = () => {
    onToggle(value);
  };

  return (
    <FilterChip
      label={label}
      icon={icon}
      isChecked={isChecked}
      onToggle={handleToggle}
      hideLabelOnMobile={hideLabelOnMobile}
      sx={sx}
    />
  );
};

export default VehicleCheckBox;
